module.exports = __webpack_public_path__ + "static/media/edit.d7e198f7.svg";